var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('div',{ref:"completeRadioAllChart",staticClass:"chart"}),_vm._v(" "),_c('div',{staticClass:"info"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ec0bb96","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics-charts/insurance-statistics/components/v1/CompleteRadioAll/ChartFor.vue
// module id = null
// module chunks = 